import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 140 140"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "14",
      d: "M135 135H10a5 5 0 0 1-4-9l53-52a5 5 0 0 0 0-8L6 14a5 5 0 0 1 4-9h125"
    }, null, -1)
  ]));
}
const Sigma = { render };
export {
  Sigma as default,
  render
};
//# sourceMappingURL=Sigma.svg.js.map
